//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import search from '@/components/search/index.vue'
import { getListByCode, getLIstByCodeSimple } from '@/common/js/dictionary.js'
export default {
  data() {
    return {
      city: {
        name: '地区',
        code: ''
      },
      actions: [],
      showSheet: false,
      isFixed: false,
      form: {
        bodyName: '', // 名称（模糊查询）
        districtCode: '', // 区县code
        cityCode: '',
        provinceCode: '',
        labelCode: '',
        orderByIndex: 10
      },
      end: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        // name: '',
        loading: false,
        finished: false
      },
      list: [],
      menu: [ // 筛选菜单栏
        // {
        //   title: '城市', // 标题
        //   option: [], // 筛选菜单的数组
        //   isDefault: false // 是否使用默认样式
        // },
        {
          title: '类型',
          detailList: []
        },
        {
          title: '排序',
          style: "columnar",
          detailList: [{ name: '默认', code: 10 }, { name: '销量从高到低', code: 21 }, { name: '评分从高到低', code: 60 }, { name: '价格从高到低', code: 31 }, { name: '价格从低到高', code: 30 }
            // , { text: '评分高到低', value: 4 }
          ]
        }
      ]
    }
  },
  components: {
    uniLoadMore,
    search
  },
  onLoad(event) {
    this.form.cityCode = event.cityCode || ''
    this.init()
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.page.count) {
      this.queryData()
    }
  },
  methods: {
    async init() {
      let list = await getListByCode('scenicTag', '/weChat/ticket/queryLabelByCode', true)
      // this.labelList = Array.isArray(list) ? [{ name: '全部', code: '' }].concat(list) : []
      this.menu[0].detailList = list
      // this.getRegions () 
      this.queryData()
    },
    getRegions() {
      let code = '330700000000'
      let data = getLIstByCodeSimple(code)
      data.then(result => {
        this.actions = result.map(t => {
          return {
            name: t.name,
            code: t.code
          }
        })
        this.actions.unshift({
          name: '金华市',
          code: ''
        })
        // this.city.name = '金华市'
        this.city = this.actions[0]
        // this.columns[0].values = this.actions.map(t => {
        //   return t.name
        // })
      })
    },
    handleClick(item) {
      uni.navigateTo({
        url: `/pages/beauty/detail?id=${item.scenicspotId}`
      })
    },
    nameInput(event) {
      this.form.bodyName = event.target.value || ''
    },
    querySearchData() {
      this.page.currentPage = 1
      this.list = []
      this.finished = false
      this.queryData()
    },
    confirm(item) {
      // console.log(item)
      if (item.index === 0) {
        this.form.labelCode = item.code || ''
      } else if (item.index === 1) {
        this.form.orderByIndex = item.code || ''
      }
      this.querySearchData()
    },
    changePicker(item) {
      // console.log('changePicker',item)
      // let districtCode = item.cityCode ? item.cityCode+'000000' : ''
      let label = item.label ? item.label : '请选择'
      // this.form.districtCode = districtCode
      // this.city.code = districtCode
      this.city.name = label
      this.genAreaCode(item.cityCode)
      // this.form.districtCode = this.actions[index] ? this.actions[index].code : ''
      // this.city = this.actions[index] ? this.actions[index] : this.actions[0]
      this.querySearchData()
    },
    genAreaCode(cityCode) {
      // console.log('genCode',cityCode)
      if (cityCode.area) {
        this.form.districtCode = cityCode.area + '000000'
        this.city.code = this.form.districtCode
      } else if (cityCode.city) {
        this.form.cityCode = cityCode.city + '00000000'
        this.city.code = this.form.cityCode
      } else if (cityCode.province) {
        this.form.provinceCode = cityCode.province + '0000000000'
        this.city.code = this.form.provinceCode
      } else {
        this.form.provinceCode = ''
        this.form.cityCode = ''
        this.form.districtCode = ''
        this.city.code = ''
      }
    },
    reset(index) {
      // console.log(index)
      if (index === 0) {
        this.form.labelCode = ''
      } else if (index === 1) {
        this.form.orderByIndex = 10
      }
      this.querySearchData()
    },
    queryData(status) {
      // console.log('query', this.form)
      // 异步更新数据
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/ticket/queryBodyPage',
        data: {
          ...this.form,
          ...this.page,
          cityCode: this.form.cityCode || '',
          isSelling: 0
        }
      }).then(data => {
        this.page.count = data.count
        this.list.push.apply(this.list, this.renderData(data.data))
        if (this.list.length >= this.page.count) {
          this.end = true
        }
        this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        this.page.loading = false
      })
    },
    renderData(data) {
      return data.map(t => {
        return {
          ...t,
          scenicspotId: t.bodyId,
          name: t.bodyName,
          coverImagesUrl: t.cover,
          photoImagesUrls: t.images,
          rank: t.starType <= 5 ? t.starType : 5,
          tagList: t.labelName ? t.labelName.split(',') : []
          // itemType: t.labelName ? (t.labelName.split(',')).shift() : '' // 暂时只取一个标签 - 2.0升3.0的不要标签了
        }
      })
    }
  }
}
